import * as React from 'react';
import { cn } from '../../../utils';

export interface SpeakPanelProps {
  /** avatar letter, e.g. "M" */
  initial: React.ReactNode;
  /** condensed uppercase title, e.g. "Conversation with Mel" */
  title: React.ReactNode;
  /** muted description line */
  description?: React.ReactNode;
  /** action slot on the right, typically a <ZineButton> ("Start speaking") */
  action?: React.ReactNode;
  /**
   * The exercise instructions (markdown already rendered), full-width under the
   * header row and above the conversation UI, so the panel reads
   * title → instructions → Start.
   */
  intro?: React.ReactNode;
  /** expanded live-conversation UI, rendered full-width below the header row */
  children?: React.ReactNode;
  className?: string;
}

/**
 * Dark speaking panel: radial-gradient avatar circle with initial,
 * condensed title, muted description and an action button. Children
 * render below as the expanded conversation UI.
 */
export function SpeakPanel({
  initial,
  title,
  description,
  action,
  intro,
  children,
  className,
}: SpeakPanelProps) {
  return (
    <div className={cn('z-speak-panel', className)}>
      <div className="z-avatar">{initial}</div>
      <div>
        <h4 className="z-speak-title">{title}</h4>
        {description != null && <p className="z-speak-desc">{description}</p>}
      </div>
      {action != null && <div className="z-speak-action">{action}</div>}
      {intro != null && <div className="z-speak-intro">{intro}</div>}
      {children != null && <div className="z-speak-extra">{children}</div>}
    </div>
  );
}
